module.exports = __webpack_public_path__ + "img/logo-white.66daec21.png";